import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { Subscription } from 'rxjs';

export type Section = 'Legal Notice' | 'Privacy Policy' | 'Cookie Policy';

@Component({
  standalone: false,
  selector: 'app-legal-text-modal',
  templateUrl: './legal-text.component.html',
  styleUrls: ['./legal-text.component.css'],
})
export class LegalTextModalComponent implements OnInit, OnDestroy {
  private dialogRef = inject(BrnDialogRef);
  currentSection: Section = 'Legal Notice';
  subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.initComponent();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private initComponent(): void {}

  close() {
    this.dialogRef.close();
  }
}
